export default __webpack_public_path__ + "static/media/icon-alert-danger.32b19972.svg";